import React from "react"
import {
    Container,
    Col,
    Row} from 'reactstrap';
    import humanmap from "./images/humanmap.png"
import Header from "./Header"

function Humanitarian(){
    return(
        <div>
            <Header/>
            <br/>
            <br/>
            <Container>
                <Row>
                <Col xs="12" xl={{ size: 10, offset: 1 }}>
                    <h2 className="display-3 text-left">The human cost</h2>
                    <br/>
                    </Col>
                </Row>
                <Row>
                <Col>
                    <img className="img-fluid" src={humanmap}/>
<p>As the air raids continue, Yemenis are unable to access the food and health services they urgently need to survive.</p>
<p>Children, the elderly, disabled persons and the chronically ill are at particularly high risk of starvation and sickness.</p>
<p>According to the UN, more than 11 million children are in need of aid, that's almost every child in the country.</p>
                    <p>Amna Ali, whose three-year-old daughter died from malnutrition, said she feared for the fate of the other children in her village in Hajjah province.</p>
                    <p>"My daughter had malnutrition and her condition was so bad that you could count the ribs on her chest," she told Al Jazeera.</p>
                    <p>"Her feet were swollen but on the rest of her body you could see all of her bones. Hours before her death, the swelling disappeared and she returned to skin and bones."</p>
                    <p>With a child dying every ten minutes, the UN has described the situation as a "war against children".</p>
                    <p>"Yemen has become a living hell," Geert Cappelaere, UNICEF’s regional director told Al Jazeera.</p>
                    <p>"A brutal war that has become a war on children. For which children have no single responsibility to bear.". </p>
                    </Col>
                </Row>
            </Container>
            <hr/>
        </div>
    )
}
export default Humanitarian

